import { ReactNode, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';
import { QuipliLink } from '../link/quipli-link';
import { useParams } from 'react-router-dom';
import './tab-navigation.scss';

type Tab = {
  id: string;
  name: string;
  url: string;
};

type TabNav = {
  className?: string;
  tabs: Tab[];
  selectedTabName: string;
  onSelect: (tab: string) => ReactNode;
};

export const TabNavigation = forwardRef(({ tabs, onSelect }: TabNav, ref) => {
  const { tab } = useParams();

  const [selectedTabName, setSelectedTabName] = useState<string>(tab && tab.length > 0 ? tab : 'setup');
  const [content, setContent] = useState<ReactNode>();
  function onTabChange(tab: string) {
    setSelectedTabName(tab);
    setContent(onSelect(tab));
  }

  useEffect(() => {
    setContent(onSelect(selectedTabName));
  }, []);

  // Set tab from the outside
  useImperativeHandle(
    ref,
    () => {
      return {
        setTab(tab: string) {
          onTabChange(tab);
        },
      };
    },
    [],
  );

  return (
    <>
      <div className="tabs-navigation">
        <div className="tabs-wrapper">
          {tabs.map((tab: Tab, i) => (
            <div
              key={i}
              className={classNames('tab-item', { active: selectedTabName === tab.id })}
              //onClick={() => onSelect(selectedTabName)}
              onClick={() => onTabChange(tab.id)}
            >
              <QuipliLink to={tab.url}>
                <Typography
                  className={classNames('whitespace-nowrap text-[var(--grey-500)]', {
                    '!text-[var(--quipli-black-800)]': tab.name === selectedTabName,
                  })}
                  weight="semi-bold"
                  type="text-sm"
                >
                  {tab.name}
                </Typography>
              </QuipliLink>
              <div className="divider-active"></div>
            </div>
          ))}
        </div>
      </div>
      <div>{content}</div>
    </>
  );
});
